var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48px",
  height: "48px",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "icons/ green / arrow-pointing-to-left (2)") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icons/-green-/-arrow-pointing-to-left-(2)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-pointing-to-right-(2)",
  transform: "translate(12.000000, 16.000000)",
  fill: "#02339c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.6731199,7.60577583 L16.5311263,0.33280653 C16.0953754,-0.11093551 15.3886751,-0.11093551 14.9529242,0.33280653 C14.5170841,0.776639481 14.5170841,1.49611797 14.9529242,1.93995092 L20.1898803,7.27294657 L1.1159365,7.27294657 C0.499671729,7.27294657 0,7.78178169 0,8.40934803 C0,9.03682345 0.499671729,9.54574948 1.1159365,9.54574948 L20.1898803,9.54574948 L14.9531028,14.8787451 C14.5172626,15.3225781 14.5172626,16.0420566 14.9531028,16.4858895 C15.1709336,16.7076242 15.4566133,16.8187188 15.7422038,16.8187188 C16.0277943,16.8187188 16.3133847,16.7076242 16.5313048,16.4858895 L23.6731199,9.21292022 C24.10896,8.76908727 24.10896,8.04960878 23.6731199,7.60577583 Z",
  id: "Path",
  transform: "translate(12.000000, 8.409359) scale(-1, 1) translate(-12.000000, -8.409359) "
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.db9bce896f07719c091d961a1f679879.svg";